$(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	/* if in drawer mode */
	$(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $("ul.tabs li").removeClass("active");
	  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
	
	
	/* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
	$('ul.tabs li').last().addClass("tab_last");

// Get the modal
var modal = document.getElementById("enquirePopup");

// Get the button that opens the modal
var btn = document.getElementById("enquireBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
if (modal && btn) {
  btn.onclick = function() {
    //alert('test');
    modal.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if (modal && span) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.addEventListener("click", function(event) {
  if (modal && event.target == modal) {
    modal.style.display = "none";
  }
});

$(document).on('click', 'span.close', function(){
	$(modal).css('display','none');
})

$(document).on('click', '.qty-plus', function () {
   $(this).prev().val(+$(this).prev().val() + 1);
});
$(document).on('click', '.qty-minus', function () {
   if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1);
});

$('ul.tabs-new li').click(function(){
  var tab_id = $(this).attr('data-tab');

  $('ul.tabs-new li').removeClass('current');
  $('.tab-content-new').removeClass('current');

  $(this).addClass('current');
  $("#"+tab_id).addClass('current');
});
